import { FC } from 'react';
import { IFileUploadStatus } from 'models/fileUpload';
import { bytesToMegaBytes } from '@/utils';
import { UploadCloudIcon } from '@/lib';
import { CSVIcon } from '@/components/icons';
import { truncateMiddle } from '@/utils/words';
import { Tooltip } from '@/components/tooltips';

type UploadingFileProps = {
  fileUpload: IFileUploadStatus;
  filename: string;
};

export const UploadingFile: FC<UploadingFileProps> = ({ filename, fileUpload }) => (
  <>
    <CSVIcon className='size-5 text-gray-500' />

    <div className='flex grow flex-col'>
      <Tooltip tooltipContent={filename}>
        <p className='text-sm text-gray-900 text-start'>{truncateMiddle(filename, 25)}</p>
      </Tooltip>
      <div className='flex items-center gap-2 text-sm text-gray-600'>
        <span>{bytesToMegaBytes(fileUpload.percentage.total)}MB</span>
        <span>|</span>
        <div className='flex items-center gap-1'>
          <UploadCloudIcon className='size-5 text-gray-400' />
          <span>{`${fileUpload.percentage.percentageCompleted}%`}</span>
        </div>
      </div>
    </div>
  </>
);
